import { DialogBody } from "./dialog-body";
import { DialogClose } from "./dialog-close";
import { DialogDescription } from "./dialog-description";
import { DialogFooter } from "./dialog-footer";
import { DialogHeader } from "./dialog-header";
import { DialogRoot } from "./dialog-root";
import { DialogTitle } from "./dialog-title";

/**
 * Dialog — centered modal molecule.
 *
 * Compound API:
 *   `<Dialog.Root open onOpenChange size dismissible divider overlay portalHost>`
 *     `<Dialog.Header align>` (left or center)
 *       `<Dialog.Title>`, `<Dialog.Description>`, optional trailing `Dialog.Close`
 *     `</Dialog.Header>`
 *     `<Dialog.Body>` (scrolls past 85dvh)
 *     `<Dialog.Footer layout>` (sticky bottom buttons, in a row or stacked)
 *   `</Dialog.Root>`
 *
 * Controlled-only — imperative open/close lives at the DS-046 AdaptiveModal
 * organism level.
 */
export const Dialog = {
  Root: DialogRoot,
  Header: DialogHeader,
  Title: DialogTitle,
  Description: DialogDescription,
  Body: DialogBody,
  Footer: DialogFooter,
  Close: DialogClose,
};
